module.exports = __webpack_public_path__ + "img/otb.5d2cdade.png";